import {
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideToastr } from 'ngx-toastr';
import { provideSpinnerConfig } from 'ngx-spinner';
import { HttpErrorInterceptor } from './core/interceptors/http-error.interceptor';
import { TokenInterceptor } from './core/interceptors/token.interceptor';
import { NgxPaginationModule } from 'ngx-pagination';
import { GoogleMapsModule } from '@angular/google-maps';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAnimations(),
    provideToastr(),
    provideSpinnerConfig({
      type: 'line-spin-clockwise-fade',
    }),
    provideHttpClient(
      withInterceptors([HttpErrorInterceptor, TokenInterceptor])
    ),
    importProvidersFrom([NgxPaginationModule, GoogleMapsModule]),
    provideRouter(
      routes,
      withHashLocation()
    ),
  ],
};
// import { provideFirebaseApp, initializeApp } from '@angular/fire/firebase-app';
// import { provideMessaging, getMessaging } from '@angular/fire/firebase-messaging';
// Firebase providers commented out to allow build without Firebase
// provideFirebaseApp(() =>
//   initializeApp({
//     apiKey: `${environment.FIREBASE_API_KEY}`,
//     authDomain: `${environment.FIREBASE_AUTH_DOMAIN}`,
//     projectId: `${environment.FIREBASE_PROJECT_ID}`,
//     storageBucket: `${environment.FIREBASE_STORAGE_BUCKET}`,
//     messagingSenderId: `${environment.FIREBASE_MESSAGING_SENDER_ID}`,
//     appId: `${environment.FIREBASE_APP_ID}`,
//     measurementId: `${environment.FIREBASE_MEASUREMENT_ID}`,
//   })
// ),
// provideMessaging(() => getMessaging()),
